webpackJsonp([246501157640856],{

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(33);
	
	var _core = __webpack_require__(17);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  card: {
	    minWidth: 275
	  },
	  bullet: {
	    display: 'inline-block',
	    margin: '0 2px',
	    transform: 'scale(0.8)'
	  },
	  title: {
	    marginBottom: 16,
	    fontSize: 14
	  },
	  pos: {
	    marginBottom: 12
	  }
	};
	
	function EventCard(props) {
	  var classes = props.classes;
	
	  var data = props.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _core.Card,
	      { className: classes.card },
	      _react2.default.createElement(
	        _core.CardContent,
	        null,
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'headline', component: 'h2' },
	          data.name
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { className: classes.pos, color: 'textSecondary' },
	          data.dates
	        ),
	        _react2.default.createElement(
	          _core.Typography,
	          { variant: 'headline', component: 'h4' },
	          data.price
	        )
	      ),
	      _react2.default.createElement(
	        _core.CardActions,
	        null,
	        _react2.default.createElement(
	          _core.Button,
	          { component: _gatsbyLink2.default, to: data.eventKey },
	          'Vaata j\xE4rgi...'
	        )
	      )
	    )
	  );
	}
	
	EventCard.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _styles.withStyles)(styles)(EventCard);
	module.exports = exports['default'];

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactMarkdown = __webpack_require__(22);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _core = __webpack_require__(17);
	
	var _styled = __webpack_require__(18);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EventCard = __webpack_require__(438);
	
	var _EventCard2 = _interopRequireDefault(_EventCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardWrapperGrid = (0, _styled2.default)(_core.Grid)(function (theme) {
	  return {
	    container: true,
	    spacing: 16,
	    fontSize: '0.75em'
	  };
	});
	
	var CardGrid = (0, _styled2.default)(_core.Grid)(function (theme) {
	  return {
	    textAlign: 'center'
	  };
	});
	
	var overal = '\nMe korraldame ka avalikke s\xFCndmuseid. Leiate meie s\xFCndmuste seast endale sobiliku seikluse. On v\xF5imalik osaleda nii individuaalselt kui ka kogu perega.\n';
	
	var event1Json = {
	  "dates": "19-20.02.2022",
	  "name": "Pereseiklus - Suusa & laua nädalavahetus Võnnus (Cēsis, Läti)",
	  "price": "al. 80€",
	  "eventKey": "/ozolkalns" };
	
	var eventSoomaaJson = {
	  "dates": "16-17.04.2022",
	  "name": "Isad ja pojad kanuumatk Soomaal 16-17 aprillil",
	  "price": "al. 85€",
	  "eventKey": "/soomaa" };
	
	var Services = function Services(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(
	      _core.Grid,
	      { item: true, xs: 12, sm: 8 },
	      _react2.default.createElement(_reactHelmet2.default, { title: 'S\xFCndmused' }),
	      _react2.default.createElement(
	        _core.Typography,
	        { variant: 'display1' },
	        'S\xFCndmused'
	      ),
	      _react2.default.createElement(_core.Typography, { component: _reactMarkdown2.default, source: overal, escapeHtml: false })
	    )
	  );
	};
	exports.default = Services;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-js-6348d9cf71d055c471bd.js